﻿import ActivePage from "../activePage";

export default class AgentPage extends ActivePage {

    constructor() {
        super();

        this.contactLettersFilter = {};
        this.currentLetterEntryContact = 0;
        this.agentContactLetterEditMode = false;
        this.lastSelectedContactRow = null;
        this.lastSelectedContact = null;
        this.agentContactLettersContainer = "agentContactLetters";
        this.lastSelectedLetter = null;
    }

    initialize(agentId) {
        this.editableGrids = [
            {
                name: 'agentContactsGrid', isDirty: false, filter: { agentId: agentId }, afterSubmit: this.updateRecordStamps
            },
            {
                name: 'agentContactLettersGrid', isDirty: false, filter: this.getContactLettersFilter,
                afterSubmit: this.contacts_resetEditedFlag,
                onDirty: () => { this.agentContactLetterEditMode = true; },
                onCancel: this.contacts_resetEditedFlag
            },
            {
                name: 'agentCEFeesGrid', isDirty: false, filter: { agentId: agentId }, afterSubmit: this.updateRecordStamps
            }
        ];

        $(document).ready(() => {
            const agentContactsGrid = $("#agentContactsGrid");

            agentContactsGrid.on("click", ".contactLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = agentContactsGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.ContactID);
                pageHelper.openLink(linkUrl, false);
            });

            agentContactsGrid.on("click", ".letter-entry", (e) => {
                e.stopPropagation();

                const element = $(e.target);
                const agentId = element.data("agent-id");
                const contactId = element.data("contact-id");

                if (!this.agentContactLetterEditMode) {
                    const parentRow = element.parents("tr.k-state-selected");
                    if (parentRow) {
                        parentRow.addClass("contact-selected");
                        this.lastSelectedContactRow = parentRow;
                    }

                    this.currentLetterEntryContact = contactId;
                    this.contacts_ShowLetterTypeEntry(agentId, contactId);
                }

            });
        });
    }

    valueMapper = (options, url) => {
        if (!url)
            url = $("body").data("base-url") + "/Shared/Agent/ValueMapper";

        $.ajax({
            url: url,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }

    deleteContactRow = (e,row) => {
        if (!this.agentContactLetterEditMode) {
            this.deleteGridRow(e, row);
        }
    }

    contacts_ShowLetterTypeEntry = (agentId, contactId) => {
        $(`#${this.agentContactLettersContainer}`).show();
        this.contactLettersFilter = { EntityType: "A", EntityId: agentId, ContactId: contactId };
        const agentContactLettersGrid = $("#agentContactLettersGrid").data("kendoGrid");
        agentContactLettersGrid.dataSource.read();
    }

    contacts_onRowSelect = (row) => {
        if (!this.agentContactLetterEditMode) {
            $(`#${this.agentContactLettersContainer}`).hide();
            //const data = row.sender.dataItem(row.sender.select());
            //if (data.GenAllLetters !== 2) {
            //}
        }
        else {
            $(this.lastSelectedContactRow).addClass("k-state-selected");
        }
    }

    contacts_updateName = (property, value,id) => {
        this.lastSelectedContact[property] = value;
        this.lastSelectedContact.dirty = true;
        if (id > 0)
            this.lastSelectedContact.ContactID = id;
    }

    contacts_onEdit = (e) => {
        const selected = e.sender.select();
        if (selected && selected.length > 0)
            this.lastSelectedContact = e.sender.dataItem(selected);
        else
            this.lastSelectedContact = e.sender.dataSource._data[0];

        if (this.agentContactLetterEditMode) {
            e.sender.closeCell();
            e.preventDefault();
        }
    }

    letters_onEdit = (e) => {
        const selected = e.sender.select();
        if (selected && selected.length > 0)
            this.lastSelectedLetter = e.sender.dataItem(selected);
        else
            this.lastSelectedLetter = e.sender.dataSource._data[0];
    }

    letters_updateName = (property, value) => {
        this.lastSelectedLetter[property] = value;
        //this.lastSelectedContact.dirty = true;
        
    }

    //hide letter settings if contact is deleted
    contacts_onRemove() {
        $("#agentContactLetters").hide();
    }

    contacts_resetEditedFlag = () => {
        this.agentContactLetterEditMode = false;
        this.currentLetterEntryContact = 0;
    }

    getContactLettersFilter = () => {
        return { contactLettersFilter: this.contactLettersFilter };
    }



}





